/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = this.closest('.section-main-product');
        this.mainProductForm = this.section.querySelector('.js-product');
        this.buyButtons = this.section.querySelector('buy-buttons');
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantContainer = this.querySelector('.sticky-atc__details__variant');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));

        this.throttledOnScroll = throttle(StickyAtc.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      /**
       * Handles submission of the product form.
       * @param {object} evt - Event object.
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('product-form buy-buttons input[name="id"]').value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }

        // Validate main form
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductForm.form.reportValidity()) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductForm.form.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Copy data
        this.form.querySelectorAll('[data-copied]').forEach((el) => el.remove());
        const formData = new FormData(this.mainProductForm.form);
        for (const p of formData) {
          if (!this.form.querySelector(`[name="${p[0]}"]`)) {
            const input = document.createElement('input');
            input.name = p[0];
            input.value = p[1];
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.form.append(input);
          }
        }
        super.handleSubmit(evt);
      }

      /**
       * Determine visibility after scroll.
       */
      static handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky') ? document.querySelector('.section-header').offsetHeight : 0;
        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset
        );

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      /**
       * Handle a change in variant on the page.
       * @param {Event} evt - Variant change event dispatched by variant-picker.
       */
   onVariantChange(evt) {
  const idInput = this.form?.querySelector('[name="id"]');
  const variant = evt.detail.variant;

  // Small money formatting helper
  const formatMoney = (amount) => {
    return (amount / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: document.documentElement.lang === 'nl' ? 'EUR' : 'USD' // change if needed
    });
  };

  if (variant) {
    this.variantTitle.textContent = variant.title;
    this.variantContainer.hidden = false;
    if (idInput) idInput.value = variant.id;

    // Update sticky ATC price
    const priceContainer = this.querySelector('.sticky-atc-price');
    if (priceContainer) {
      const priceEl = priceContainer.querySelector('.reg-stc-pr');
      const compareEl = priceContainer.querySelector('.reg-stc-cpr');
      const saveEl = this.querySelector('.reg-save-atc');

      // Update both text content and data attributes
      priceEl.textContent = formatMoney(variant.price);
      priceEl.setAttribute('data-p', variant.price); // Update data-p attribute

      if (variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.setAttribute('data-cp', variant.compare_at_price); // Update data-cp attribute
          compareEl.hidden = false;
        }
        if (saveEl) {
          const savings = variant.compare_at_price - variant.price;
          const percentSaved = Math.round((savings * 100) / variant.compare_at_price);
          saveEl.textContent = ` bespaar (${percentSaved}%)`;
          saveEl.hidden = false;
        }
      } else {
        if (compareEl) {
          compareEl.hidden = true;
          compareEl.removeAttribute('data-cp'); // Remove data-cp if no compare price
        }
        if (saveEl) saveEl.hidden = true;
      }
    }

  } else {
    this.variantContainer.hidden = true;
    this.variantTitle.textContent = '';
    if (idInput) idInput.value = '';
  }

  this.updateImage();
  this.updateAddToCartButton(variant);
  this.setErrorMsgState();
}



      /**
       * Updates the image.
       */
      updateImage() {
        const mainImage = this.section.querySelector('.media-gallery .main-image .slider__item.is-active .product-media img');
        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      /**
       * Updates the "Add to Cart" button label and status.
       * @param {object} variant - Current variant object.
       */
      updateAddToCartButton(variant) {
        if (!this.submitBtn) return;

        const variantAvailable = variant && variant.available;
        const unavailableStr = variant
          ? theme.strings.noStock : this.submitBtn.dataset.unavailableText;

        this.submitBtn.textContent = variantAvailable
          ? this.submitBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  function initStickyATC() {
    const priceEl = document.querySelector(".reg-stc-pr");
    const quantityInput = document.querySelector(".sticky-atc__buttons input[name='quantity']");
    const addToCartBtn = document.querySelector(".sticky-atc__buttons .add-to-cart");
    const discountWidget = document.querySelector(".quantity-x-product-widget");

    if (!priceEl || !quantityInput || !addToCartBtn) return false; // element missing → keep waiting

    // Base price from data attribute (in cents)
    const basePrice = parseInt(priceEl.dataset.p, 10);

    // Format cents → Euro
    function formatPrice(cents) {
      return (cents / 100).toLocaleString("nl-NL", {
        style: "currency",
        currency: "EUR"
      });
    }

    // Ensure span for price
    function ensurePriceSpan() {
      let priceSpan = addToCartBtn.querySelector(".btn-price");
      if (!priceSpan) {
        priceSpan = document.createElement("span");
        priceSpan.className = "btn-price";
        priceSpan.style.display = "block";
        priceSpan.style.fontSize = "14px";
        priceSpan.style.fontWeight = "normal";
        addToCartBtn.appendChild(priceSpan);
      }
      return priceSpan;
    }

    // Function to get discount %
    function getDiscount(qty) {
      if (qty >= 50) return 20;
      if (qty >= 20) return 15;
      if (qty >= 10) return 12;
      if (qty >= 5) return 10;
      return 0;
    }

    // Update price in button
    function updateButtonPrice() {
      const qty = parseInt(quantityInput.value, 10) || 1;
      let total = basePrice * qty;

      if (discountWidget) {
        const discount = getDiscount(qty);
        if (discount > 0) {
          total = total - (total * discount / 100);
        }
      }

      const priceSpan = ensurePriceSpan();
      priceSpan.textContent = formatPrice(Math.round(total));
    }

    // Init
    updateButtonPrice();

    // Events
    quantityInput.addEventListener("change", updateButtonPrice);
    quantityInput.addEventListener("input", updateButtonPrice);

    return true; // success
  }

  // Keep checking until element appears
  const checker = setInterval(() => {
    if (initStickyATC()) {
      clearInterval(checker);
    }
  }, 300);

  // 👉 Swatches listener (adjust selector if needed)
  document.querySelectorAll(".option-selector input[type='radio']").forEach((swatch) => {
    swatch.addEventListener("change", () => {
      setTimeout(() => {
        initStickyATC(); // re-init sticky ATC after swatch change
      }, 200);
    });
  });
});
